export default __webpack_public_path__ + "static/media/palm.16d88497.gif";